import { forwardRef } from 'react';

import type { OfferData } from '@wwe-portal/entities/offer.type';
import { SubscriptionTier } from '@wwe-portal/entities/subscription.type';
import { OfferGrid } from '@wwe-portal/ui/features/offer/offer-card';
import { SectionLayout } from './section-layout';

export interface ExclusiveItemSectionRevampProps {
  exclusiveItems: Record<SubscriptionTier, OfferData[]> | undefined;
  titles: Record<SubscriptionTier, React.ReactNode>;
  descriptions: Record<SubscriptionTier, React.ReactNode>;
  enabled: Record<SubscriptionTier, boolean>;
}

export const ExclusiveItemsSectionRevamp = forwardRef<
  HTMLDivElement,
  ExclusiveItemSectionRevampProps
>(({ exclusiveItems, titles, descriptions, enabled }, ref) => {
  return (
    <div className="flex flex-col gap-y-6" ref={ref}>
      {[SubscriptionTier.GOLD, SubscriptionTier.SILVER, SubscriptionTier.BRONZE]
        .filter((tier) => enabled[tier])
        .map((tier) => (
          <SectionLayout
            description={descriptions[tier]}
            key={tier}
            title={titles[tier]}
          >
            {exclusiveItems && <OfferGrid offers={exclusiveItems[tier]} />}
          </SectionLayout>
        ))}
    </div>
  );
});

ExclusiveItemsSectionRevamp.displayName = 'ExclusiveItemsSectionRevamp';
